import { Button, Icon, Modal } from 'semantic-ui-react';
import React, { useCallback, useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { firestore } from '../firebaseConfig';

const LegalModal = (props) => {
  let { linkTitle, company, legalType } = props;
  const [content, setContent] = useState('');
  const [contentDownloaded, setContentDownloaded] = useState();
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(false);
  const [simpleLinkOut, setSimpleLinkOut] = useState();

  const fetchContent = useCallback(async function(company, url, contentDownloaded, setContent, setContentDownloaded) {
    try {
      if (!!url && !contentDownloaded) {
        if (url.includes('cdn.yourdocket.com')) {

          const response = await fetch(url);
          let text = await response.text();
          setContentDownloaded(text);
          text = text
            .replace(/\[SENDER\]/g, company.properties.legalBusinessName || company.properties.businessName)
            .replace(/\[CONTACT\]/g, company.properties.email)
            .replace(/\[LINK\]/g, company.properties.privacyUrl);

          setContent(renderContentByExtension(url, text));
        } else {

          let json = await firestore.collection('public')
            .doc(company.teamId)
            .get()
            .then((doc) => {
              if(!doc.exists || doc.data() === undefined){
                throw new Error('No data found for this company');
              } else {
                return doc.data();
              }
            });

          setContentDownloaded(json);
          if (json?.filename && json.data) {
            setContent(renderContentByExtension(json.filename, json.data));
          }
        }
      }
    } catch (err) {
      setError(err.toString());
    }
  }, [renderContentByExtension]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  function renderContentByExtension(filename, content) {
    const extension = filename.split('.').pop();

    switch (extension) {
      case 'txt':
        /* falls through */
      case 'md':
      case 'markdown':
        return (
          <div className="markdown-content">
            <ReactMarkdown children={content} />
          </div>
        );
      case 'html':
        return <div dangerouslySetInnerHTML={{ __html: content }} />;

      default:
        return error || 'Unknown file type.';
    }
  }

  useEffect(() => {
    let url = '';
    if (!!company?.properties?.businessName) {
      // need a business name to verify this company exists, beyond placeholder data.
      switch (legalType) {
        case 'PRIVACY':
          url = company?.properties?.privacyUrl || 'cdn.yourdocket.com/default/privacy.txt';
          break;
        case 'TOS':
          url = company?.properties?.tosUrl || 'cdn.yourdocket.com/default/tos.txt';
          break;
        default:
          break;
      }
    }
    if (!!url) {
      if (!url.toLowerCase().startsWith('http')) {
        url = `https://${url}`; // just going to assume we add https for web address missing the proto
      }
      if (!url.includes('cdn.yourdocket.com')) {
        return setSimpleLinkOut(url);
      } else if (open) {
        fetchContent(company, url, contentDownloaded, setContent, setContentDownloaded);
      }
    }
  }, [company, legalType, open, contentDownloaded, fetchContent]);

  if (simpleLinkOut) {
    return (
      <a href={simpleLinkOut} target="_blank" rel="noreferrer">
        {props.children}
      </a>
    );
  }

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      trigger={
        <button type="button" onClick={() => setOpen(false)}>
          {props.children}
        </button>
      }
    >
      <Modal.Header>{linkTitle}</Modal.Header>
      <Modal.Content image scrolling>
        <Modal.Description style={{ width: '99%' }}>{content}</Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => setOpen(false)} primary>
          Close <Icon name="chevron right" />
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default LegalModal;
